import { CURRENCY_FORMAT } from "../../../../utils/constants/appConstants";
import {
  formatCurrencyAmount,
  formatDateWithDayjs
} from "../../../../utils/utils";

export const COLUMNS = [
  {
    Header: "DATE",
    Footer: "DATE",
    accessor: "paymentDate",
    Cell: ({ value }) => {
      if (value) {
        return formatDateWithDayjs(value, "DD-MMM-YYYY");
      } else {
        return "";
      }
    }
  },
  {
    Header: "AMOUNT",
    Footer: "AMOUNT",
    accessor: "amount",
    Cell: ({ value, row }) => {
      const isReversed = row.original?.xeroStatus === "payment_reversed";

      const formattedAmount = `${CURRENCY_FORMAT}${formatCurrencyAmount(value)}`;

      return isReversed ? `-${formattedAmount}` : formattedAmount;
    }
  },
  {
    Header: "TYPE",
    Footer: "TYPE",
    accessor: "type",
    Cell: ({ value }) => {
      return value
        ? value
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
        : "";
    }
  },
  {
    Header: "XERO STATUS",
    Footer: "XERO STATUS",
    accessor: "xeroStatus",
    Cell: ({ value }) => {
      return value
        ? value
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
        : "";
    }
  },
  {
    Header: "GOCARDLESS STATUS",
    Footer: "GOCARDLESS STATUS",
    accessor: "gocardlessStatus",
    Cell: ({ value }) => {
      return value
        ? value
            .split("_")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
        : "";
    }
  }
];
